import { axios } from '../../../../axios';

const updateUser = (data) => {
  return axios.put(`/users/info`, data)
}
const getMyInfoApi = () => {
  return axios.get(`/users/info`)
}

export {updateUser, getMyInfoApi}